// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutocompleteController from "./autocomplete_controller.js"
application.register("autocomplete", AutocompleteController)

import AuthorsController from "./authors_controller.js"
application.register("authors", AuthorsController)

import ClipboardController from "./clipboard_controller.js"
application.register("clipboard", ClipboardController)

import ConditionalFormsController from "./conditional_forms_controller.js"
application.register("conditional_forms", ConditionalFormsController)

import GlobalController from "./global_controller.js"
application.register("global", GlobalController)

import ItemsController from "./items_controller.js"
application.register("items", ItemsController)

import LicensesController from "./licenses_controller.js"
application.register("licenses", LicensesController)

import MultiFieldsController from "./multi_fields_controller.js"
application.register("multi_fields", MultiFieldsController)

import NestedAttributesController from "./nested_attributes_controller.js"
application.register("nested_attributes", NestedAttributesController)

import TimeoutController from "./timeout_controller"
application.register("timeout", TimeoutController)

import TinymceController from "./tinymce_controller.js"
application.register("tinymce", TinymceController)
